<template>
  <div class="row">
    <div class="col-lg-8 col-md-6 p-0">
      <project-card :title="`${tableTitle}`"
        description="<i class='fa fa-check text-info' aria-hidden='true'></i> <span class='font-weight-bold ms-1'>30 done</span> this month"
        :headers="['Page', 'Action', 'Description']" :projects="dashboardData" 
        :highlightRequestNewSkills="shouldHighlightRequestNewSkills"
        :highlightSetupWizard="props.highlightSetupWizard"
        @view-page="handleViewPage" />
    </div>
    <div class="col-lg-4 col-md-6">
      <timeline-list class="h-100" :title="cardTitle" :summarylist="summarylist" :type="type">
        <timeline-item v-for="(item, index) in cardContent" :key="index" :type="type" :title="item.activityname"
          :date-time="item.starttime || item.instancedate" :statusid="item.statusid"
          :status="item.status || item.statusname"
          :method="item.method || item.scheduling_method"
          :isAutoScheduled="checkIsAutoScheduled(item)"
          :total_workgroups="item.total_workgroups ?? item.total_workgroups_count"
          :total_persons_confirmed="item.total_persons_confirmed || item.confirmed_count"
          :total_persons_declined="item.total_persons_declined || item.declined_count"
          :total_persons_needed="item.total_persons_needed || item.total_persons_needed_count"
          :total_persons_scheduled="item.total_persons_scheduled || item.total_assigned_count"
          :workgroupname="item.workgroupname" :showPersonCounts="type === 'admin'" />
      </timeline-list>
    </div>
  </div>

  <!-- <div class="col-lg-8 col-md-6 mt-4 p-0">
    <project-card :title="`New Routes of ${tableTitle}`"
      description="<i class='fa fa-check text-info' aria-hidden='true'></i> <span class='font-weight-bold ms-1'>30 done</span> this month"
      :headers="['Page', 'Description', 'View']" :projects="dashboardData" @view-page="handleViewPage" />
  </div> -->
</template>

<script setup>
import { computed, watch } from "vue";
import { useStore } from "vuex";
import ProjectCard from "./ProjectCard.vue";
import TimelineList from "@/components/Cards/TimelineList.vue";
import TimelineItem from "@/components/Cards/TimelineItem.vue";
import { getLocationId, getLogginedPersonId } from "../../utils/SessionDataHandler";
import { processUriPlaceholders } from "@/utils/UriHandler";

// ✅ Props
const props = defineProps({
  tableTitle: {
    type: String,
  },
  cardTitle: {
    type: String,
  },
  tableContent: {
    type: Object,
  },
  cardContent: {
    type: Object,
  },
  summarylist: {
    type: [Array, null],
    default: null,
  },
  type: {
    type: String,
  },
  highlightRequestNewSkills: {
    type: Boolean,
    default: false,
  },
  highlightSetupWizard: {
    type: Boolean,
    default: false,
  }
});

// ✅ Emit
const emit = defineEmits(["view-page"]);

const store = useStore();
const stDashboardTableCards = computed(() => store.getters.stDashboardTableCards);
const stVolunteerModules = computed(() => store.getters.stVolunteerModules);

// Use the prop if provided, otherwise calculate it (for backward compatibility)
const shouldHighlightRequestNewSkills = computed(() => {
  // If prop is explicitly provided, use it
  if (props.highlightRequestNewSkills !== undefined) {
    return props.highlightRequestNewSkills;
  }
  
  // Otherwise, calculate it (for cases where prop is not passed)
  if (props.type !== 'volunteer') {
    return false;
  }
  
  const stSessionData = store.getters.stSessionData;
  const personSkills = store.getters.getPersonSkills || [];
  
  // Check if user is NOT an admin in the location
  const isAdmin = stSessionData?.isAdminInLocation || false;
  if (isAdmin) {
    return false;
  }
  
  // Check if user has no skills
  const hasSkills = personSkills.length > 0;
  if (hasSkills) {
    return false;
  }
  
  // User is not admin AND has no skills - highlight the row
  return true;
});

// Process dashboard table cards with dynamic URIs
const dashboardData = computed(() => {
  // Use volunteer modules if available and type is volunteer, otherwise use dashboard table cards
  const modulesToUse = (props.type === 'volunteer' && stVolunteerModules.value && stVolunteerModules.value.length > 0)
    ? stVolunteerModules.value
    : stDashboardTableCards.value;

  if (!modulesToUse || modulesToUse.length === 0) {
    return [];
  }

  return processUriPlaceholders(modulesToUse, {
    locationId: getLocationId(),
    personId: getLogginedPersonId()
  });
});


// Helper to check if activity is auto-scheduled
function checkIsAutoScheduled(item) {
  // Check various possible field names and values
  const method = (item.method || item.scheduling_method || '').toLowerCase();
  const isAuto = method === 'auto' || method === 'automated' || method === 'automatic';
  const hasAutoFlag = item.is_auto_scheduled === true || item.is_auto_scheduled === 1 || 
                      item.isautoscheduled === true || item.isautoscheduled === 1 ||
                      item.auto_scheduled === true || item.auto_scheduled === 1;
  return isAuto || hasAutoFlag;
}

// Debug: Log first activity item to see available fields
watch(() => props.cardContent, (newContent) => {
  if (newContent && newContent.length > 0) {
    console.log('Upcoming Activities - First item fields:', Object.keys(newContent[0]));
    console.log('Upcoming Activities - First item data:', newContent[0]);
  }
}, { immediate: true });

// ✅ Methods
function handleViewPage(payload) {
  console.log("payload", payload);
  if (payload.uri_type === "modal") {
    emit("view-page", payload);
    return;
  }

  if (payload.uri_type === "page") {
    window.location.href = payload.uri;
  }
}
</script>